// @flow

export const QUERY = 'redux/video-elephant/QUERY';
export const QUERY_RESULT = 'redux/video-elephant/QUERY_RESULT';
export const QUERY_ERROR = 'redux/video-elephant/QUERY_ERROR';

export const INCREMENT_COUNT = 'redux/video-elephant/INCREMENT_COUNT';

export const VIDEO_ELEPHANT_QUERY = 'redux/video-elephant/VIDEO_ELEPHANT_QUERY';
